import { useEffect, useState } from 'react';
import { INNER_CARD_BORDER_RADIUS } from 'developer-docs-shared-components/config/cssConstants';
import { Flex } from 'foundations-components/components/Flex';
import { Spacer } from 'foundations-components/components/Spacer';
import { Text } from 'foundations-components/components/Text';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import ProductTierIcon from './ProductTierIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * BaseProductTier has minimal layout styling applied, so that the consumer can determine the positioning of the component on the page
 */

const Wrapper = styled.div.withConfig({
  displayName: "BaseProductTier__Wrapper",
  componentId: "sc-5k9rpq-0"
})(["box-shadow:", ";border-radius:", "px;margin-bottom:", ";"], ({
  theme
}) => theme.boxShadow['300'], INNER_CARD_BORDER_RADIUS, ({
  theme
}) => theme.space[800]);
const Header = styled.div.withConfig({
  displayName: "BaseProductTier__Header",
  componentId: "sc-5k9rpq-1"
})(["background-color:", ";padding:", ";border-radius:", "px ", "px 0 0;"], ({
  theme
}) => theme.color['fill-tertiary-default'], ({
  theme
}) => theme.space[600], INNER_CARD_BORDER_RADIUS, INNER_CARD_BORDER_RADIUS);
const TIER_VALUES = ['free', 'starter', 'professional', 'enterprise'];
const PRODUCT_LABELS = {
  marketing_hub: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "developer-docs-mdx-components.productTier.marketingHubProductName",
    useGap: true
  }),
  sales_hub: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "developer-docs-mdx-components.productTier.salesHubProductName",
    useGap: true
  }),
  service_hub: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "developer-docs-mdx-components.productTier.serviceHubProductName",
    useGap: true
  }),
  cms: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "developer-docs-mdx-components.productTier.contentHubProductName",
    useGap: true
  }),
  operations_hub: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "developer-docs-mdx-components.productTier.operationsHubProductName",
    useGap: true
  })
};
const BaseProductTier = props => {
  const {
    tiers
  } = props;
  const [minimums, setMinimums] = useState({});
  useEffect(() => {
    const newMinimums = {};
    const setMinIfRequired = newProductTier => {
      const productThenTier = newProductTier.split('-');
      const newIndex = TIER_VALUES.indexOf(productThenTier[1]);
      if (newMinimums[productThenTier[0]] && newIndex < newMinimums[productThenTier[0]]) {
        newMinimums[productThenTier[0]] = newIndex;
      } else if (typeof newMinimums[productThenTier[0]] === 'undefined') {
        newMinimums[productThenTier[0]] = newIndex;
      }
    };
    for (let i = 0; i < tiers.length; i++) {
      if (tiers[i].includes('marketing_hub')) {
        setMinIfRequired(tiers[i]);
      } else if (tiers[i].includes('sales_hub')) {
        setMinIfRequired(tiers[i]);
      } else if (tiers[i].includes('service_hub')) {
        setMinIfRequired(tiers[i]);
      } else if (tiers[i].includes('cms-')) {
        setMinIfRequired(tiers[i]);
      } else if (tiers[i].includes('operations_hub')) {
        setMinIfRequired(tiers[i]);
      }
    }
    setMinimums(newMinimums);
  }, [tiers]);
  const products = Object.keys(minimums);
  return /*#__PURE__*/_jsxs(Wrapper, {
    children: [/*#__PURE__*/_jsx(Header, {
      children: /*#__PURE__*/_jsx(Text, {
        as: "h4",
        typography: "heading-100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "developer-docs-mdx-components.productTier.header"
        })
      })
    }), /*#__PURE__*/_jsx(Text, {
      paddingInlineStart: "300",
      paddingInlineEnd: "300",
      paddingBlockStart: "500",
      typography: "detail-100",
      margin: "0",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-mdx-components.productTier.description"
      })
    }), /*#__PURE__*/_jsx(List, {
      paddingInlineStart: "300",
      paddingInlineEnd: "300",
      paddingBlockStart: "400",
      paddingBlockEnd: "200",
      children: products.map(product => {
        const tier = TIER_VALUES[minimums[product]];
        return /*#__PURE__*/_jsx(ListItem, {
          marginBlockEnd: "400",
          children: /*#__PURE__*/_jsxs(Flex, {
            alignItems: "center",
            children: [/*#__PURE__*/_jsx(ProductTierIcon, {
              tier: product
            }), /*#__PURE__*/_jsx(Spacer, {
              marginBlockEnd: "100",
              display: "inline-block"
            }), /*#__PURE__*/_jsx(Text, {
              as: "strong",
              typography: "heading-100",
              display: "inline-block",
              paddingInlineEnd: "100",
              children: PRODUCT_LABELS[product]
            }), /*#__PURE__*/_jsx(Text, {
              as: "span",
              children: "-"
            }), /*#__PURE__*/_jsx(Text, {
              typography: "body-200",
              display: "inline-block",
              paddingInlineStart: "100",
              as: "span",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: `developer-docs-mdx-components.productTier.${tier}ProductTier`
              })
            })]
          })
        }, product);
      })
    })]
  });
};
export default BaseProductTier;